/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useEffect, useState } from 'react';
import { createTheme } from '@material-ui/core/styles';
import { postMergeTheme, preMergeTheme } from './theme';
import { useConfiguration } from '../../redux/features/configuration/useConfiguration';
import { ConfigResourceProps } from '../../redux/enums/ConfigResourceProps';

export function useTheming() {
  const [ready, setReady] = useState(false);
  const [theme, setTheme] = useState();
  const frontendCustomisation = useConfiguration(ConfigResourceProps.FRONTEND_CUSTOMISATION);

  // Build theme (NPO + EPO) and load it
  useEffect(() => {
    (async () => {
      // Whenever NPO theme is loaded
      if (frontendCustomisation.ready) {
        // If final theme is not already built
        if (!theme) {
          const themeTmp = createTheme(preMergeTheme, frontendCustomisation.resource);
          const muiTheme = createTheme(themeTmp, postMergeTheme(themeTmp));
          setTheme(muiTheme);
          setReady(true);
        }
      }
    })();
  }, [frontendCustomisation.resource]);

  return {
    ready,
    theme,
  };
}
